import { createTheme } from '@mui/material/styles';

const Theme = createTheme({
    palette: {
        primary: {
            main: '#213C85',
            light: '#FFFFFF',
            contrastText: '#FFFFFF',
            dark: '#223265',

        },
        secondary: {
            light: '#71C7F8',
            main: '#FFFFFF',
            dark: '#3F51B5',
            contrastText: '#FFFFFF'
        },
        text:
        {
            secondary: '#AAAAAA'
        },

    },

    typography: {

    },
    shape: {
        borderRadius: 5
    },

});

export default (Theme);